import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import Tabs from "@mui/material/Tabs";
import { styled, Stack, Paper } from "@mui/material";
import { IoSearchSharp } from "react-icons/io5";
import Tab from "@mui/material/Tab";
import {
  setcontactlist,
  updateNotification,
  clearnotifyAll,
} from "../../../Redux/Actions/actions";
import { Box } from "@mui/material";
import { Smartx_BaseUrl, BaseUrl } from "../../../Container/BaseUrl/BaseUrl";
import SockJS from "sockjs-client";
import Stomp from "stompjs";
import axios from "axios";
import Skeleton from "@mui/material/Skeleton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import "./Customer-Detail-Search.style.css";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { useDebounce } from "../../../Layout/Contacts/hooks";

// Component
import UserDetails2 from "./User-Details2.component";
import InteractionTabTableFormat from "./user-list-child-component/InteractionTabTableFormat.component";
import Sessiontab from "./user-list-child-component/Session-tab.component";
import FilesTab from "./user-list-child-component/Files-tab.component";
import SurveyTab from "./user-list-child-component/Survey-tab.component";
import SmartAssist from "./user-list-child-component/SmartAssist";
import UserDetailsHeader from "./UserDetailsHeader";
import CrmComponent from "./CrmComponent";
import HospitalityComponent from "./HospitalityComponent";
import UserListComponent from "./User-list.component";
import ChatBotScript from "./ChatBotScript";
import VideoChat from "./VideoChat";
import CobrowseChat from "./CobrowseChat";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#e9e9e9",
    color: theme.palette.common.black,
    padding: "7px 10px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
  },
}));

const StyledTableCell2 = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.root}`]: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    padding: "7px 10px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
  },
}));

const mapStateToProps = (state) => {
  const { contactListData, data } = state;
  return {
    externalChatData: contactListData.externalChatData,
    userlistshow: data.userlistshow,
    CurrentTab: contactListData.CurrentTab,
  };
};

const UserlistComponent2 = (props) => {
  const { handleSendMsg } = props;
  const [editUser, setEditUser] = useState(true);
  let permission = JSON.parse(localStorage.getItem("permission"));
  const [value, setvalue] = useState(0);
  let selectedChat = JSON.parse(localStorage.getItem("client"));
  let agentId = JSON.parse(localStorage.getItem("tokenAgent"));
  const [smartxdata, setSmartxdata] = useState([]);
  const [smartxdataloader, setSmartxdataloader] = useState(false);
  const stompClient = useRef(null);

  const [key, setkey] = useState(0);
  const [customerlist, setCustomerlist] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [selectedCustomer, setselectedCustomer] = useState();
  const [loader, setloader] = useState(false);
  const debouncedSearch = useDebounce(searchValue);

  const connectWebSocket = () => {
    try {
      const newsocket = new SockJS(
        "https://avayaistc.inaipi.me:8443/smartx/eventwebsocket-endpoint"
      );
      stompClient.current = Stomp.over(newsocket);
      stompClient.current.connect({}, function () {
        stompClient.current.subscribe(
          `/topic/agent_${agentId.agent_id}`,
          function (msg) {
            const randomChars = Math.random().toString(36).substring(2, 10);
            const timestamp = new Date().getTime().toString(36);
            const randomId = randomChars + timestamp;
            var newNotification = {
              id: randomId,
              username: "smartx",
              client_msg: msg.body,
              from_id: "",
              chatType: "",
            };
            props.updateNotification(newNotification);
          }
        );
      });
    } catch (error) {
      stompClient.current.onerror = function (error) {
        console.log("WebSocket Error: ", error);
      };
    }
  };

  const fetchsmartxData = () => {
    setSmartxdataloader(true);
    axios
      .get(
        Smartx_BaseUrl +
          `/requestDetails/viewRequest/${
            selectedChat ? selectedChat.RequestId : ""
          }/${agentId.agent_id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        if (res.data.status == "OK") {
          setSmartxdataloader(false);
          setSmartxdata(res.data.data);
        } else {
          setSmartxdataloader(false);
          setSmartxdata([]);
        }
      })
      .catch(() => {
        setSmartxdataloader(false);
        setSmartxdata([]);
      });
  };

  const handleChange = (event, newValue) => {
    setvalue(newValue);
  };

  // useEffect(() => {
  //   props.clearnotifyAll();
  //   connectWebSocket();
  //   fetchsmartxData();
  // }, [props.externalChatData]);

  const customerListApi = () => {
    setloader(true);
    let body = {
      emailId: debouncedSearch,
      phonenumber: debouncedSearch,
    };
    axios
      .post(BaseUrl + "/users/getcustomerdetails", body, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        if (res.data.success) {
          setCustomerlist(res.data.data);
          setTimeout(() => {
            setloader(false);
          }, 1000);
        } else {
          setCustomerlist([]);
          setTimeout(() => {
            setloader(false);
          }, 1000);
        }
      })

      .catch((error) => {});
  };
  useEffect(() => {
    if (debouncedSearch.length >= 3) {
      customerListApi();
    } else if (debouncedSearch.length == 0) {
      setCustomerlist([]);
    }
  }, [debouncedSearch]);

  return (
    <Box
      sx={{
        height: "100%",
        width: props.userlistshow ? "50vw" : "100vw",
        display: "flex",
        flexDirection: "column",
        gap: "3px",
        background: "#EEF7FF",
        overflow: "hidden",
      }}
    >
      <UserDetailsHeader />

      {(() => {
        switch (props.CurrentTab) {
          case "customerDetails":
            return (
              <>
                <Box
                  className="checkbox-container"
                  sx={{
                    height: "200px",
                    width: "100%",
                    padding: "5px",
                    overflowY: "hidden",
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                    background: "white",
                    justifyContent: "flex-start",
                    alignItems: "start",
                  }}
                >
                  <UserDetails2 editUser={editUser} setEditUser={setEditUser} />

                  {props.externalChatData?.channel == "from_purple" && (
                    <div
                      className="d-flex text-start"
                      style={{
                        fontSize: "11px",
                        fontWeight: 600,
                        userSelect: "none",
                        color: "#0d407ebf",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      <label>Logged In User</label>
                      <input
                        checked={
                          props.externalChatData
                            ? props.externalChatData?.agent_logged == "LoggedIn"
                              ? true
                              : false
                            : false
                        }
                        type="checkbox"
                      />
                    </div>
                  )}
                </Box>
                <Box
                  sx={{
                    height: "calc(100% - 200px)",
                    width: "100%",
                    boxShadow: "#cfd1d6e8 -8px 2px 0px,#c8c8c86b 0px 1px 5px",
                    background: "white",
                  }}
                >
                  {/* tab header */}
                  <Box
                    sx={{
                      height: "48px",
                      width: "100%",
                      boxShadow:
                        "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
                      background: "white",
                    }}
                  >
                    <Tabs value={value} onChange={handleChange} centered>
                      {/* Interaction History  */}
                      {permission.map((module) => {
                        if (module.moduleName === "INTERACTION") {
                          const value = module.screen.find(
                            (item) =>
                              item.screenId === "INTERACTION_HISTORY" &&
                              item.read &&
                              item.write
                          );
                          if (value) {
                            return (
                              <Tab
                                variant="scrollable"
                                scrollButtons="auto"
                                aria-label="scrollable auto tabs example"
                                key={0}
                                label="Interaction History"
                                sx={{
                                  width: "20%",
                                  padding: "5px",
                                  fontWeight: 600,
                                  color: "black",
                                  fontSize: 10,
                                  "&:hover": {
                                    backgroundColor: "#C2E7FF",
                                  },
                                }}
                              />
                            );
                          } else {
                            return (
                              <Tab
                                variant="scrollable"
                                scrollButtons="auto"
                                aria-label="scrollable auto tabs example"
                                key={0}
                                disabled
                                label="Interaction History"
                                sx={{
                                  width: "20%",
                                  padding: "5px",
                                  fontWeight: 600,
                                  color: "black",
                                  fontSize: 10,
                                  "&:hover": {
                                    backgroundColor: "#C2E7FF",
                                  },
                                }}
                              />
                            );
                          }
                        }
                      })}
                      {/* Session History */}
                      {permission.map((module) => {
                        if (module.moduleName === "INTERACTION") {
                          const value = module.screen.find(
                            (item) =>
                              item.screenId === "SESSION_HISTORY" &&
                              item.read &&
                              item.write
                          );
                          if (value) {
                            return (
                              <Tab
                                key={1}
                                label="Session History"
                                sx={{
                                  width: "20%",
                                  padding: "5px",
                                  fontWeight: 600,
                                  color: "black",
                                  fontSize: 10,
                                  "&:hover": {
                                    backgroundColor: "#C2E7FF",
                                  },
                                }}
                              />
                            );
                          } else {
                            return (
                              <Tab
                                key={1}
                                label="Session History"
                                sx={{
                                  width: "20%",
                                  padding: "5px",
                                  fontWeight: 600,
                                  color: "black",
                                  fontSize: 10,
                                  "&:hover": {
                                    backgroundColor: "#C2E7FF",
                                  },
                                }}
                              />
                            );
                          }
                        }
                      })}
                      {/* SmartX History  */}
                      {permission.map((module) => {
                        if (module.moduleName === "INTERACTION") {
                          const value = module.screen.find(
                            (item) =>
                              item.screenId === "SMARTX" &&
                              item.read &&
                              item.write
                          );
                          if (value) {
                            return (
                              <Tab
                                key={2}
                                label="Smart Assist"
                                sx={{
                                  width: "20%",
                                  padding: "5px",
                                  fontWeight: 600,
                                  color: "black",
                                  fontSize: 10,
                                  "&:hover": {
                                    backgroundColor: "#C2E7FF",
                                  },
                                }}
                              />
                            );
                          } else {
                            return (
                              <Tab
                                key={2}
                                label="Smart Assist"
                                disabled
                                sx={{
                                  width: "20%",
                                  padding: "5px",
                                  fontWeight: 600,
                                  color: "black",
                                  fontSize: 10,
                                  "&:hover": {
                                    backgroundColor: "#C2E7FF",
                                  },
                                }}
                              />
                            );
                          }
                        }
                      })}
                      {/* Files History  */}
                      {permission.map((module) => {
                        if (module.moduleName === "INTERACTION") {
                          const value = module.screen.find(
                            (item) =>
                              item.screenId === "FILE" &&
                              item.read &&
                              item.write
                          );
                          if (value) {
                            return (
                              <Tab
                                key={3}
                                label="File"
                                sx={{
                                  width: "20%",
                                  padding: "5px",
                                  fontWeight: 600,
                                  color: "black",
                                  fontSize: 10,
                                  "&:hover": {
                                    backgroundColor: "#C2E7FF",
                                  },
                                }}
                              />
                            );
                          } else {
                            return (
                              <Tab
                                key={3}
                                label="File"
                                disabled
                                sx={{
                                  width: "20%",
                                  padding: "5px",
                                  fontWeight: 600,
                                  color: "black",
                                  fontSize: 10,
                                  "&:hover": {
                                    backgroundColor: "#C2E7FF",
                                  },
                                }}
                              />
                            );
                          }
                        }
                      })}
                      {/* Survey  History  */}
                      {permission.map((module) => {
                        if (module.moduleName === "INTERACTION") {
                          const value = module.screen.find(
                            (item) =>
                              item.screenId === "SURVEY_DETAILS" &&
                              item.read &&
                              item.write
                          );
                          if (value) {
                            return (
                              <Tab
                                key={4}
                                label="Survey"
                                sx={{
                                  width: "20%",
                                  padding: "5px",
                                  fontWeight: 600,
                                  color: "black",
                                  fontSize: 10,
                                  "&:hover": {
                                    backgroundColor: "#C2E7FF",
                                  },
                                }}
                              />
                            );
                          } else {
                            return (
                              <Tab
                                key={4}
                                label="Survey"
                                disabled
                                sx={{
                                  width: "20%",
                                  padding: "5px",
                                  fontWeight: 600,
                                  color: "black",
                                  fontSize: 10,
                                  "&:hover": {
                                    backgroundColor: "#C2E7FF",
                                  },
                                }}
                              />
                            );
                          }
                        }
                      })}
                    </Tabs>
                  </Box>
                  {/* tab content  */}
                  <Box
                    sx={{
                      height: "calc(100% - 49px)",
                      width: "100%",
                      padding: "8px",
                    }}
                  >
                    <div style={{ height: "100%", overflow: "hidden" }}>
                      {(() => {
                        switch (value) {
                          case 0:
                            return <InteractionTabTableFormat />;
                          case 1:
                            return <Sessiontab />;
                          case 2:
                            return (
                              <SmartAssist
                                smartxdata={smartxdata}
                                smartxdataloader={smartxdataloader}
                              />
                            );
                          case 3:
                            return <FilesTab handleSendMsg={handleSendMsg} />;
                          case 4:
                            return <SurveyTab />;
                          default:
                            return <></>;
                        }
                      })()}
                    </div>
                  </Box>
                </Box>
              </>
            );
          case "Crm":
            return <CrmComponent />;
          case "Hospitality":
            return <HospitalityComponent />;
          case "customerSearch":
            return (
              <Paper sx={{ height: "100%", padding: "10px 15px" }}>
                {(() => {
                  switch (key) {
                    case 0:
                      return (
                        <Stack spacing={1}>
                          <Box className="search-btn-main">
                            <div className="group position-relative">
                              <IoSearchSharp className="searchicon" />
                              <input
                                className="customer-search-input"
                                onChange={(e) => setSearchValue(e.target.value)}
                                value={searchValue}
                                type="search"
                                id="search-input-box"
                                placeholder="Search"
                              />
                            </div>
                          </Box>
                          <TableContainer className="CONTACT-LIST-AREA">
                            <Table stickyHeader aria-label="sticky table fs-13">
                              <TableHead>
                                <TableRow>
                                  {[
                                    { label: "Name", minWidth: 60 },
                                    { label: "Email", minWidth: 60 },
                                    { label: "Phone Number", minWidth: 60 },
                                  ].map((item, index) => (
                                    <StyledTableCell
                                      key={index}
                                      style={{ minWidth: item.minWidth }}
                                    >
                                      {item.label}
                                    </StyledTableCell>
                                  ))}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {customerlist.length ? (
                                  customerlist.map((el) => (
                                    <TableRow
                                      hover
                                      role="checkbox"
                                      tabIndex={-1}
                                      key={el.id}
                                      sx={{ cursor: "pointer" }}
                                      onClick={() => {
                                        setkey(1);
                                        setselectedCustomer(el);
                                      }}
                                    >
                                      <StyledTableCell2>
                                        {loader ? (
                                          <Skeleton
                                            animation="wave"
                                            variant="rectangular"
                                            width={150}
                                          />
                                        ) : (
                                          <>{el.username}</>
                                        )}
                                      </StyledTableCell2>
                                      <StyledTableCell2>
                                        {loader ? (
                                          <Skeleton
                                            animation="wave"
                                            variant="rectangular"
                                            width={150}
                                          />
                                        ) : (
                                          <>{el.email}</>
                                        )}
                                      </StyledTableCell2>
                                      <StyledTableCell2>
                                        {loader ? (
                                          <Skeleton
                                            animation="wave"
                                            variant="rectangular"
                                            width={150}
                                          />
                                        ) : (
                                          <>{el.phonenumber}</>
                                        )}
                                      </StyledTableCell2>
                                    </TableRow>
                                  ))
                                ) : (
                                  <TableRow
                                    hover
                                    role="checkbox"
                                    tabIndex={-1}
                                    sx={{ cursor: "pointer" }}
                                  >
                                    <StyledTableCell2>No Data</StyledTableCell2>
                                    <StyledTableCell2>No Data</StyledTableCell2>
                                    <StyledTableCell2>No Data</StyledTableCell2>
                                  </TableRow>
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Stack>
                      );
                    case 1:
                      return (
                        <UserListComponent
                          selectedCustomer={selectedCustomer}
                          customerSearch={true}
                          setkey={setkey}
                        />
                      );
                    default:
                      return <></>;
                  }
                })()}
              </Paper>
            );
          case "Chatbot":
            return <ChatBotScript />;
          case "videoChat":
            return <VideoChat />;
          case "cobrowseChat":
            return <CobrowseChat />;
          default:
            break;
        }
      })()}
    </Box>
  );
};

export default connect(mapStateToProps, {
  setcontactlist,
  updateNotification,
  clearnotifyAll,
})(UserlistComponent2);
